var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-chip",
        { attrs: { outlined: "" } },
        [
          _vm._v(
            " " +
              _vm._s(
                _setup.environments[_vm.item[_vm.header.value]] ||
                  "Não identificado"
              ) +
              " "
          ),
          _c("v-icon", { attrs: { right: "", small: "", color: "grey" } }, [
            _vm._v(" mdi-server "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }